import Vue from 'vue';

export async function listarPreguntasValoracion(accessToken) {
  const response = await Vue.axios.get('/valoracion-preguntas', {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data.data;
}

export async function obtenerValoracionesProveedor(accessToken, proveedorId) {
  const response = await Vue.axios.get(`/proveedores/${proveedorId}/valoraciones`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}

export async function obtenerValoracionesReserva(accessToken, reservaId) {
  const response = await Vue.axios.get(`/reservas/${reservaId}/valoraciones`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}

export async function obtenerResumenValoraciones(accessToken) {
  const response = await Vue.axios.get('/valoraciones/resumen', {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}
